import { browserTracingIntegration, type BrowserOptions } from "@sentry/react";
import { beforeSendTransaction } from "./beforeSendTransaction";
import { shouldCreateSpanForRequest } from "./shouldCreateSpanForRequest";
import { SHARED_IGNORE_ERRORS } from "./ignoreErrors";

export interface SentryConfigOptions {
  dsn: string;
  environment: string;
  enabled: boolean;
  release: string;
  tracesSampleRate?: number;
  ignoreErrors?: (string | RegExp)[];
  integrations?: BrowserOptions["integrations"];
}

export const createSentryConfig = ({
  dsn,
  environment,
  enabled,
  release,
  tracesSampleRate = 0.05,
  ignoreErrors = [],
  integrations
}: SentryConfigOptions): BrowserOptions => ({
  dsn,
  environment,
  enabled,
  release,
  integrations: integrations ?? [
    browserTracingIntegration({
      shouldCreateSpanForRequest,
      enableLongTask: false,
      enableInp: false,
      enableHTTPTimings: false
    })
  ],
  tracesSampleRate,
  beforeSendTransaction,
  ignoreErrors: [...SHARED_IGNORE_ERRORS, ...ignoreErrors]
});
